import { ImageTag } from './image-tag.model';

export class Image {
  id: number = -1;
  name: string = '';
  friendly_name: string = '';
  tissue_type: string = '';
  tumor_subtype: string = '';
  thumb_src: string = '';
  tiles_dzi: string = '';
  metadata: any = {};
  order: number = 0;
  is_diagnostic: boolean | null = false;
  image_evaluated: boolean | null = false;
  diagnostic_evaluated: boolean | null = false;
  macro_image_src: string = '';
  already_viewed: boolean = false;
  deleted_at: string | null = null;
  num_revisions: number = 0;
  tags: ImageTag[] = [];
}
